import { render, staticRenderFns } from "./RecipeCard.vue?vue&type=template&id=bd057f0c&"
import script from "./RecipeCard.vue?vue&type=script&lang=js&"
export * from "./RecipeCard.vue?vue&type=script&lang=js&"
import style0 from "./RecipeCard.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports